import React from 'react';
import { motion } from 'framer-motion';
import { useSuperOrganizations } from './hooks/useSuperOrganizations';
import { SuperOrganizationsHeader } from './components/SuperOrganizationsHeader';
import { SuperOrganizationsFilters } from './components/SuperOrganizationsFilters';
import { SuperOrganizationsTable } from './components/SuperOrganizationsTable';
import { Pagination } from '../../../../shared/components/molecules/Pagination/Pagination';

export function SuperOrganizations() {
  const {
    searchTerm,
    setSearchTerm,
    selectedPlanFilter,
    setSelectedPlanFilter,
    page,
    setPage,
    limit,
    sortBy,
    sortOrder,
    handleSort,
    handlePageChange,
    handleDeleteClick,
    isDeletingId,
    organizations,
    pagination,
    isLoading,
    isFetching,
    isError,
    navigate
  } = useSuperOrganizations();

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      style={{
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box'
      }}
    >
      {/* Page Header */}
      <SuperOrganizationsHeader />

      {/* Filters Bar */}
      <SuperOrganizationsFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedPlanFilter={selectedPlanFilter}
        setSelectedPlanFilter={setSelectedPlanFilter}
        setPage={setPage}
      />

      {/* Main Data Table */}
      <SuperOrganizationsTable
        organizations={organizations}
        isLoading={isLoading}
        isFetching={isFetching}
        isError={isError}
        page={page}
        limit={limit}
        sortBy={sortBy}
        sortOrder={sortOrder}
        handleSort={handleSort}
        handleDeleteClick={handleDeleteClick}
        isDeletingId={isDeletingId}
        navigate={navigate}
      />

      {/* Pagination Controls */}
      {!isLoading && !isError && organizations.length > 0 && (
        <Pagination
          page={page}
          total={pagination.total || organizations.length}
          limit={pagination.limit || 10}
          onPageChange={handlePageChange}
          theme="admin"
          itemName="organizations"
        />
      )}
    </motion.div>
  );
}
